export default __webpack_public_path__ + "static/media/mary.f1983275.jpeg";